import { Field } from 'formik';
import React from 'react';
import FieldCustomInput from '../CustomFieldFormik/FieldCustomInput';

function CompanyName() {
   return <Field name="company" label="Company Name" fullWidth component={FieldCustomInput} />;
}

export default CompanyName;
